import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl} from '@angular/platform-browser';

@Pipe({
  name: 'strToFloat'
})
export class StringFloatPipe implements PipeTransform {

 public transform(valor: any): any {
     let precoStr = '';
     if (typeof(valor) === 'string') {
         if (valor.includes(',')) {
             precoStr = valor.replace(',', '.');
            return parseFloat(precoStr);
         }
     } else {
        return parseFloat(valor);
     }
  }

}
